// Generated by Melange

import * as Buhta_cabinet__Btn from "../../../html/Btn.js";
import * as Buhta_cabinet__Dropdowns from "../../../molecules/Dropdowns.js";
import * as Buhta_cabinet__Field from "../../../html/Field.js";
import * as Buhta_cabinet__Kassa from "../../../../grpc/Kassa.js";
import * as Buhta_cabinet__ToastSender from "../../../../util/ToastSender.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__Tenant from "../../../../../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../../../../../packages/core/lib/Toast.js";
import * as Curry from "melange.js/curry.js";
import * as $$Promise from "../../../../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(onClose) {
  return function (kkm) {
    const match = Buhta_core__Tenant.useTenant(undefined);
    const tenant = match[0];
    const match$1 = Buhta_core__Toast.ToastsContext.useToasts(undefined);
    const dispatchToasts = match$1[1];
    const match$2 = React.useState(function () {
          return "";
        });
    const setRegion = match$2[1];
    const region = match$2[0];
    const match$3 = React.useState(function () {
          return "";
        });
    const setCity = match$3[1];
    const city = match$3[0];
    const match$4 = React.useState(function () {
          return "";
        });
    const setStreet = match$4[1];
    const street = match$4[0];
    const match$5 = React.useState(function () {
          return "";
        });
    const setHouse = match$5[1];
    const house = match$5[0];
    const match$6 = React.useState(function () {
          return "";
        });
    const setApartment = match$6[1];
    const apartment = match$6[0];
    React.useEffect((function () {
            Curry._1(setStreet, (function (param) {
                    return kkm.address_street;
                  }));
            Curry._1(setHouse, (function (param) {
                    return kkm.address_street1;
                  }));
            Curry._1(setApartment, (function (param) {
                    return kkm.address_street2;
                  }));
          }), [kkm]);
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                      children: "Перерегистрация ККМ"
                                    }),
                                JsxRuntime.jsx("button", {
                                      children: JsxRuntime.jsx("img", {
                                            className: "w-6 h-6",
                                            src: StaticAsset.src("/static/icons/close.svg")
                                          }),
                                      onClick: (function (param) {
                                          Curry._1(onClose, undefined);
                                        })
                                    })
                              ],
                              className: "px-6 py-4 flex justify-between"
                            }),
                        JsxRuntime.jsx("hr", {}),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      className: "text-asphalt",
                                      children: "Введите новый адрес ККМ"
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx(Buhta_cabinet__Dropdowns.RegionSelect.make, {
                                            region: region,
                                            onRegionSelect: (function (value) {
                                                Curry._1(setRegion, (function (param) {
                                                        return value;
                                                      }));
                                                Curry._1(setCity, (function (param) {
                                                        return "";
                                                      }));
                                              })
                                          }),
                                      className: "mt-5"
                                    }),
                                region !== "" ? JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx(Buhta_cabinet__Dropdowns.CitySelect.make, {
                                              region: region,
                                              city: city,
                                              onCitySelect: (function (value) {
                                                  Curry._1(setCity, (function (param) {
                                                          return value;
                                                        }));
                                                })
                                            }),
                                        className: "mt-5"
                                      }) : null,
                                city !== "" ? JsxRuntime.jsxs(React.Fragment, {
                                        children: [
                                          JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                label: "Улица",
                                                type_: "text",
                                                name: "street",
                                                size: "m",
                                                required: true,
                                                onChange: (function (value) {
                                                    Curry._1(setStreet, (function (param) {
                                                            return value;
                                                          }));
                                                  }),
                                                className: "mt-5",
                                                value: street
                                              }),
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                        label: "Дом",
                                                        type_: "text",
                                                        name: "house",
                                                        size: "m",
                                                        required: true,
                                                        onChange: (function (value) {
                                                            Curry._1(setHouse, (function (param) {
                                                                    return value;
                                                                  }));
                                                          }),
                                                        value: house
                                                      }),
                                                  JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                        label: "Квартира/Офис",
                                                        type_: "text",
                                                        name: "apartment",
                                                        size: "m",
                                                        onChange: (function (value) {
                                                            Curry._1(setApartment, (function (param) {
                                                                    return value;
                                                                  }));
                                                          }),
                                                        value: apartment
                                                      })
                                                ],
                                                className: "mt-5 flex justify-between gap-4"
                                              })
                                        ]
                                      }) : null
                              ],
                              className: "px-6 py-4"
                            }),
                        JsxRuntime.jsx("hr", {}),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
                                    title: "Подписать и отправить в КГД",
                                    onClick: (function (param) {
                                        const form_address_street2 = apartment === "" ? undefined : apartment;
                                        const form = {
                                          administrative_area_code: region,
                                          locality_code: city,
                                          sublocality_code: undefined,
                                          kato: city,
                                          address_street: street,
                                          address_street1: house,
                                          address_street2: form_address_street2
                                        };
                                        const __x = Buhta_cabinet__Kassa.KkmManagerService.changeRegister(tenant, kkm.id, form);
                                        $$Promise.get(__x, (function (result) {
                                                if (result.TAG !== /* Ok */0) {
                                                  return Buhta_cabinet__ToastSender.sendGrpcErrorToast(dispatchToasts, result._0, "Ошибка при отправке формы:");
                                                }
                                                Curry._1(onClose, undefined);
                                                Curry._1(dispatchToasts, {
                                                      TAG: /* Add */0,
                                                      _0: {
                                                        id: Buhta_core__Toast.generateId(undefined),
                                                        text: "ККМ успешно перерегистрирована",
                                                        kind: "success",
                                                        onClick: (function (param) {
                                                            
                                                          })
                                                      }
                                                    });
                                              }));
                                      }),
                                    className: "py-3 w-full"
                                  }),
                              className: "px-6 py-4"
                            })
                      ],
                      className: "w-106 bg-white rounded shadow-payroll"
                    }),
                className: "absolute inset-0 bg-black/40 flex justify-center items-center"
              });
  };
}

function KkmReregisterModal(Props) {
  return make(Props.onClose)(Props.kkm);
}

const make$1 = KkmReregisterModal;

export {
  make$1 as make,
}
/* Buhta_cabinet__Btn Not a pure module */
